/**
 * React hook для работы с toast-уведомлениями
 * Дата: 27.12.2025 - Создан для TODO-007 (замена alert на toast)
 * Дата: 07.02.2026 - FIX: useCallback для стабильных ссылок (устранение бесконечных циклов useEffect)
 * Связан с: frontend/src/store/toastStore.ts, frontend/src/components/ui/Toast.tsx
 */
import { useCallback } from 'react';
import { useToastStore } from '@/store/toastStore';

export function useToast() {
  const showToast = useToastStore((state) => state.showToast);

  const showSuccess = useCallback((message: string) => showToast(message, 'success'), [showToast]);
  const showError = useCallback((message: string) => showToast(message, 'error'), [showToast]);
  const showWarning = useCallback((message: string) => showToast(message, 'warning'), [showToast]);
  const showInfo = useCallback((message: string) => showToast(message, 'info'), [showToast]);

  return { showSuccess, showError, showWarning, showInfo };
}

